// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "recommend-33HNg";
var _4 = "recommend__wrapper-1t439";
var _5 = "recommend__price-2dv5K";
var _6 = "recommend__label-2gkdC";
var _7 = "together-2UmfQ";
var _8 = "recommend__icon-UqMOq";
var _9 = "passengers__button-B-kKb";
var _a = "slider-L3kKk";
export { _1 as "__esModule", _2 as "mobile", _3 as "recommend", _4 as "recommend__wrapper", _5 as "recommend__price", _6 as "recommend__label", _7 as "together", _8 as "recommend__icon", _9 as "passengers__button", _a as "slider" }
export default { "__esModule": _1, "mobile": _2, "recommend": _3, "recommend__wrapper": _4, "recommend__price": _5, "recommend__label": _6, "together": _7, "recommend__icon": _8, "passengers__button": _9, "slider": _a }
